const partnerCardsBlockWithFilterModule =
    partnerCardsBlockWithFilterModule ||
    (() => {
        const classNamePrefix = "partner-cards-block-w-filter"
        const status = {
            isInitialized: false,
            scrollYBeforeDropdownOpened: 0,
        }
        const setUp = () => {
            const blocks = document.querySelectorAll(`.${classNamePrefix}`)
            if (blocks.length > 0) {
                blocks.forEach((block, index) => {
                    const showMoreButton = block.querySelector(`.${classNamePrefix}__show-more`)
                    const showLessButton = block.querySelector(`.${classNamePrefix}__show-less`)

                    if (showMoreButton)
                        showMoreButton.addEventListener("click", () => {
                            block.classList.add("show-all-filter")
                        })

                    if (showLessButton)
                        showLessButton.addEventListener("click", () => {
                            block.classList.remove("show-all-filter")
                        })

                    block.addEventListener("dropdown-click", (e) => {
                        const blockHeader = block.querySelector(`.${classNamePrefix}__head`)
                        if (blockHeader) {
                            const classes = blockHeader.classList
                            if (classes.contains("d-none")) {
                                window.scrollTo(0, status.scrollYBeforeDropdownOpened)
                                classes.remove("d-none")
                            } else {
                                status.scrollYBeforeDropdownOpened = window.scrollY
                                classes.add("d-none")
                            }
                        }
                    })
                })
            }

            window.addEventListener("resize", () => {
                blocks.forEach((block) => {
                    const blockHeader = block.querySelector(`.${classNamePrefix}__head`)
                    if (blockHeader && blockHeader.classList.contains("d-none")) {
                        blockHeader.classList.remove("d-none")
                    }
                })
            })
        }

        const init = () => {
            if (status.isInitialized) return
            setUp()
            status.isInitialized = true
        }
        return { init, status }
    })()

document.addEventListener("DOMContentLoaded", partnerCardsBlockWithFilterModule.init)
